import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IApiMigrationDevice } from "@app/main/modules/foundation/_routes/rv-lite/commserver-migration/commserver-migration.component";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { ICameraConfiguration } from "../_models/ICameraConfiguration";

@Injectable({
    providedIn: 'root'
})
export class ConfigManagerService {
    private configFileCacheName: string = "configFilesCache";

    constructor(
        private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService) { }

    getConfigs(invalidateCache = false): Observable<ICameraConfiguration[]> {
        return this.dataCacheService.getOrRequest(this.configFileCacheName, () => this.getConfigsFromDb(), { invalidateCache });
    }

    saveConfig(config: ICameraConfiguration): Observable<ICameraConfiguration> {
        return this.http.post<ICameraConfiguration>(`/api/cameras/commserver/configurations`, config).pipe(tap(config => {
            this.dataCacheService.addOrUpdateItem(config, this.configFileCacheName);
        }))
    }

    getMigrationConfigIds(): Observable<string[]> {
        return this.http.get<string[]>(`/api/cameras/commserver/migration/configids`);
    }

    applyMigration(migrationDevices: IApiMigrationDevice[]): Observable<IApiMigrationDevice[]> {
        return this.http.post<IApiMigrationDevice[]>(`/api/cameras/commserver/migration`, migrationDevices);
    }

    private getConfigsFromDb(): Observable<ICameraConfiguration[]> {
        return this.http.get<ICameraConfiguration[]>(`/api/cameras/commserver/configurations`);
    }
}
